/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiOicCheckIndividualPost } from '../fn/oic/api-oic-check-individual-post';
import { ApiOicCheckIndividualPost$Params } from '../fn/oic/api-oic-check-individual-post';
import { apiOicCheckMultiplePost } from '../fn/oic/api-oic-check-multiple-post';
import { ApiOicCheckMultiplePost$Params } from '../fn/oic/api-oic-check-multiple-post';
import { OicLicenseOutput } from '../models/oic-license-output';

@Injectable({ providedIn: 'root' })
export class OicService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiOicCheckIndividualPost()` */
  static readonly ApiOicCheckIndividualPostPath = '/api/Oic/CheckIndividual';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiOicCheckIndividualPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiOicCheckIndividualPost$Response(params?: ApiOicCheckIndividualPost$Params, context?: HttpContext): Observable<StrictHttpResponse<OicLicenseOutput>> {
    return apiOicCheckIndividualPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiOicCheckIndividualPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiOicCheckIndividualPost(params?: ApiOicCheckIndividualPost$Params, context?: HttpContext): Observable<OicLicenseOutput> {
    return this.apiOicCheckIndividualPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<OicLicenseOutput>): OicLicenseOutput => r.body)
    );
  }

  /** Path part for operation `apiOicCheckMultiplePost()` */
  static readonly ApiOicCheckMultiplePostPath = '/api/Oic/CheckMultiple';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiOicCheckMultiplePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiOicCheckMultiplePost$Response(params?: ApiOicCheckMultiplePost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OicLicenseOutput>>> {
    return apiOicCheckMultiplePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiOicCheckMultiplePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiOicCheckMultiplePost(params?: ApiOicCheckMultiplePost$Params, context?: HttpContext): Observable<Array<OicLicenseOutput>> {
    return this.apiOicCheckMultiplePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<OicLicenseOutput>>): Array<OicLicenseOutput> => r.body)
    );
  }

}
